import React from 'react'
import './BlockingLoader.scss'
import CircularProgress from '@material-ui/core/CircularProgress'
const RootClass = 'ap-blocking-loader'

const BlockingLoader = ({children}) => {
  return (
    <div className={`c-res-mod ${RootClass}`}>
      <div className={`${RootClass}__container`}>
        <CircularProgress />
        <div className="ap-typography" style={{marginTop: 8}}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default BlockingLoader
